import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-uffici',
  imports: [CommonModule],
  templateUrl: './uffici.html',
  styleUrls: ['./uffici.scss'],
})
export class UfficiComponent implements OnInit {
  constructor(private router: Router, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Pulizia uffici a Pescara | SAMI Pulizie',
      description:
        'Pulizia professionale uffici a Pescara: postazioni, scrivanie, pavimenti, vetri, bagni e aree comuni. Sopralluogo e preventivo gratuito.',
      keywords:
        'pulizia uffici Pescara, pulizie studi professionali, igienizzazione uffici, impresa pulizie Pescara, SAMI Pulizie',
      canonicalUrl: '/uffici',

      ogTitle: 'Pulizia uffici a Pescara | SAMI Pulizie',
      ogDescription:
        'Servizi professionali per uffici e ambienti di lavoro: pulizia, igienizzazione e piani programmati.',
      ogImage: '/assets/logo.png',
      ogType: 'website',

      twitterCard: 'summary_large_image',
      twitterTitle: 'Pulizia uffici a Pescara | SAMI Pulizie',
      twitterDescription:
        'Pulizia e igienizzazione uffici a Pescara. Sopralluogo gratuito e preventivo personalizzato.',
      twitterImage: '/assets/logo.png',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Pulizia uffici',
        description: 'Pulizie professionali per uffici: postazioni, pavimenti, vetri, bagni e aree comuni.',
        provider: {
          '@type': 'CleaningService',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/',
          logo: 'https://samipulizie.it/assets/logo.png',
        },
        areaServed: { '@type': 'AdministrativeArea', name: 'Pescara' },
        url: 'https://samipulizie.it/uffici',
      },
    });
  }

  navigateToPreventiviSito() {
    this.router.navigateByUrl('/preventivo');
  }
}
